import { render, staticRenderFns } from "./ReportingHome.vue?vue&type=template&id=5c2e39e0&scoped=true&"
import script from "./ReportingHome.vue?vue&type=script&lang=js&"
export * from "./ReportingHome.vue?vue&type=script&lang=js&"
import style0 from "./ReportingHome.vue?vue&type=style&index=0&id=5c2e39e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2e39e0",
  null
  
)

export default component.exports